import Markdown, { type MarkdownToJSX } from 'markdown-to-jsx';
import { parseEntities } from 'parse-entities';

interface Props {
	children: string;
	options?: MarkdownToJSX.Options;
}

/**
 * Do not use this unless your data is legacy data and could contain raw HTML.
 * If you do not need for legacy data, use MarkdownParser
 */
const LegacyOrMarkdownParser = ({ children, options }: Props) => {
	if (typeof children !== 'string') {
		return null;
	}
	return <Markdown options={options}>{parseEntities(children)}</Markdown>;
};

export default LegacyOrMarkdownParser;
